
export interface ScrollModalSlice {
  // Track shown modals by path
  shownModals: Record<string, boolean>;
  // Set a modal as shown for a specific path
  setModalShown: (path: string) => void;
}

// Create the scroll modal slice with proper typing
export const createScrollModalSlice = <T extends ScrollModalSlice>(
  set: (fn: (state: T) => T) => void,
  get: () => T,
  _api: any
) => ({
  shownModals: {},
  setModalShown: (path: string) => 
    set((state: T) => ({ 
      ...state,
      shownModals: { ...state.shownModals, [path]: true } 
    }))
});